import React, { useEffect, useRef, useState, useContext } from "react";
import "./Navbar.css";
import { useTranslation } from "react-i18next";
import {
  Callout,
  DirectionalHint,
  Icon,
  IconButton,
  Nav,
  PrimaryButton,
  TooltipHost,
} from "@fluentui/react";

// import { AuthRoutes } from "../../constants/navBarItemsConstants";
import HandBurgerIcon from "./nav-icons/Handburger";
import LeftArrowIcon from "./nav-icons/LeftArrowIcon";
import ArrowDownIcon from "./nav-icons/ArrowDownIcon";
import ArrowUpIcon from "./nav-icons/ArrowUpIcon";
import userContext from "../../context/users/UserContext";
import DeeptekLogo from "../SVGComponents/Logo/DeeptekLogo";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

import { customNavbarTooltipStyles, navBarItems } from "./helper/initialData";
import RowBadge from "../../pages/StudyList/components/Badge/RowBadge";
import DownloadBatchRequestsModalTrigger from "./DownloadBatchRequestsModalTrigger";
import DownArrow from "../SVGComponents/DownArrow";
import {
  AuthRoutes,
  NonAuthRoutes,
  USERTYPES, resolveBackendForHost,
} from "../../constants/Constants";
import HeaderDropdown from "./HeaderDropdown/HeaderDropdown";
import themeContext from "../../context/theme/ThemeContext";
import { RouterProvider } from "react-router-dom";
import { RouterConfig } from "../../config/RouterConfig";
import Augmento from "../SVGComponents/Logo/Augmento";
import ClearIcon from "../SVGComponents/ClearIcon";
import loaderContext from "../../context/loader/LoaderContext";
import NotAllowed from "../NotAllowed";
import CustomToolTipHost from "../CustomToolTipHost/CustomToolTipHost";
import RebrandingLogo from "../SVGComponents/Logo/RebrandingLogo";

const resolveStudyViewer = (pathname, authenticated) => {
  const isExcludedRoute =
    pathname.length == 0 ||
    pathname.length == 1 ||
    pathname.includes("/login") ||
    // pathname.includes("report") ||
    pathname.includes("patient") ||
    pathname.includes("/new/study/load") ||
    pathname.includes("study/priors/load") ||
    pathname.includes("force-change-pwd") ||
    pathname.includes("/shared/report/view") ||
    pathname.includes(NonAuthRoutes.FORGOTPASSWORD) ||
    pathname.includes(NonAuthRoutes.ENTEROTP) ||
    pathname.includes(NonAuthRoutes.RESETPASSWORD) ||
    pathname.includes(NonAuthRoutes.GIZMOWIDGET) ||
    pathname.includes(NonAuthRoutes.NEWREPORTWIDGET) ||
    pathname.includes(NonAuthRoutes.GIZMOVIEWER) ||
    pathname.includes(NonAuthRoutes.TWOFACTORAUTHENTICATION) ||
    (!authenticated && pathname.includes(AuthRoutes.PRIVACY_POLICY)) ||
    pathname.includes(AuthRoutes.SHAREDVIEWER) ||
    pathname.includes(AuthRoutes.BLITZREPORTING);

  let studyViewer = isExcludedRoute;

  if (
    isMobile &&
    (!pathname.includes("study/load") || pathname.includes("/new/study/load")) &&
    !pathname.includes(AuthRoutes.SHAREDVIEWER)
  ) {
    studyViewer = true;
  }

  return studyViewer;
};

const Navbar = (props) => {
  const {
    roles,
    authenticated,
    loadByUsername,
    userId,
    firmName,
    name,
    showPasswordExpiryMessage,
    daysRemainingForExpiry,
    handleHidePasswordExpiryMessage,
    isActiveData,
    customerSupportNumber,
    enableLlmReport,
    qcOutsourceLogin,
    routeToNodeEnabled,
    aiRouteToNodeEnabled,
  } = useContext(userContext);
  const { theme, themeName, setThemeName, setTheme, getThemeColor } =
    useContext(themeContext);
  const { enableButtonTourPurpose, showModal, setShowModal } =
    useContext(loaderContext);
  const [showNavBar, setShowNavBar] = useState(true);
  const [showHeaderOption, setShowHeaderOptions] = useState(false);
  const [hideHeaderOption, setHideHeaderOptions] = useState(false);
  const [studyViewer, setStudyViewer] = useState(() =>
    resolveStudyViewer(window.location.pathname, authenticated)
  );
  const [windowTemp, setWindow] = useState(true);
  const [list, setList] = useState();
  const [windowComplete, setWindowComplete] = useState(true);
  const [currentPath, setCurrentPath] = useState("");
  const [dropdown, setDropdown] = useState(false);
  const [delayHandler, setDelayHandler] = useState(null);
  const [closeNavbarButton, setCloseNavbarButton] = useState(false);
  const [t, i18n] = useTranslation();
  const [hoveredItem, setHoveredItem] = useState(null);
  const hideBranding = resolveBackendForHost(window.location.host).matched === true;

  useEffect(() => {
    if (!authenticated || roles.length == 0 || name.length == 0) {
      loadByUsername();
    }
    // setShowNavBar(authenticated);
  }, []);
  // }, [authenticated, roles, name]);

  useEffect(() => {
    if (enableButtonTourPurpose?.showHeader) {
      setShowHeaderOptions(true);
    } else {
      setShowHeaderOptions(false);
    }
  }, [enableButtonTourPurpose]);

  const closeNavBar = () => {
    clearTimeout(delayHandler);
    setDelayHandler(
      setTimeout(() => {
        setWindow(true);
        setWindowComplete(true);
      }, 500)
    );
  };

  const closeNavBarInstantly = () => {
    clearTimeout(delayHandler);
    setWindow(true);
    setWindowComplete(true);
    setCloseNavbarButton(false);
  };

  const openNavBar = () => {
    //clearTimeout(delayHandler);
    //setDelayHandler(
    // setTimeout(() => {
    setWindow(false);
    setWindowComplete(false);
    scrollToSelectedTab();
    //}, 500)
    //);
  };

  useEffect(() => {
    setStudyViewer(resolveStudyViewer(window.location.pathname, authenticated));
    setCurrentPath(window.location.pathname);
  }, [window.location.pathname]);

  const scrollToSelectedTab = () => {
    list.map((item) => {
      if (item.path === currentPath) {
        const element = document.getElementById(item.id);
        if (element != null) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  };

  useEffect(() => {
    clearTimeout(closeNavBar);
  }, [windowComplete]);

  let activePath = currentPath;
  // if (currentPath === AuthRoutes.FIRMDETAILS && roles[0] === USERTYPES.FIRMADMIN) {
  //   const viewFirmType = new URLSearchParams(window.location.search).get("type");
  //   if (viewFirmType === "0") activePath = AuthRoutes.CLIENTLIST;
  //   else if (viewFirmType === "1") activePath = AuthRoutes.RADIOLOGISTLIST;
  // }
  if (roles[0] === USERTYPES.FIRMADMIN) {
    if (currentPath === AuthRoutes.FIRMDETAILS || currentPath === AuthRoutes.EDITHOSPITAL) {
      const searchType = new URLSearchParams(window.location.search).get("type");
      const stateType = window.history.state?.usr?.type;
      const firmType =
        searchType !== null && searchType !== ""
          ? searchType
          : stateType !== null && stateType !== undefined && !Number.isNaN(stateType)
          ? String(stateType)
          : null;
      if (firmType === "0") activePath = AuthRoutes.CLIENTLIST;
      else if (firmType === "1") activePath = AuthRoutes.RADIOLOGISTLIST;
      else activePath = AuthRoutes.FIRMDETAILS; // own firm (no type) → keep "Firm" highlighted
    } else if (currentPath === AuthRoutes.PROVIDERVIEW) {
      activePath = AuthRoutes.RADIOLOGISTLIST; // radiologist provider view
    } else if (
      currentPath === AuthRoutes.MYEDITUSER &&
      window.history.state?.usr?.userType === USERTYPES.RADIOLOGIST
    ) {
      activePath = AuthRoutes.RADIOLOGISTLIST; // radiologist provider edit (generic /user/edit route)
    }
    console.warn("[navbar-active] firm-admin highlight resolved to", activePath, "for path", currentPath, "state:", window.history.state?.usr);
  }
  // let listTemp = navBarItems(currentPath, roles, hoveredItem, isActiveData, enableLlmReport, qcOutsourceLogin, routeToNodeEnabled, aiRouteToNodeEnabled);
  let listTemp = navBarItems(activePath, roles, hoveredItem, isActiveData, enableLlmReport, qcOutsourceLogin, routeToNodeEnabled, aiRouteToNodeEnabled);

  useEffect(() => {
    let temp = listTemp.map((ele, ind) => {
      // ele.id = "Nav-" + ind;
      return ele;
    });
    let filterShow = temp.filter((ele, ind) => {
      if (ele.show == true) return ele;
    });
    setList(temp);
  }, [currentPath, authenticated]);

  const updateDropdown = (id) => {
    const keyList = list.map((item) => {
      if (item.id === id) {
        const updatedItem = {
          ...item,
          dropped: !item.dropped,
          active: !item.active,
        };
        return updatedItem;
      }
      return item;
    });
    const newList = keyList.map((item) => {
      if (list[id.split("-")[1]].conntectId?.includes(item.id)) {
        const updatedItem = {
          ...item,
          show: !item.show,
        };
        return updatedItem;
      }
      return item;
    });
    setList(newList);
  };

  const getRoleName = (role) => {
    if (role == USERTYPES.FIRMADMIN) {
      return "FIRM ADMIN";
    } else if (role == USERTYPES.FIRMDOCTOR) {
      return "FIRM DOCTOR";
    } else if (role == USERTYPES.FIRMTECHNICIAN) {
      return "FIRM TECHNICIAN";
    } else if (role == USERTYPES.ADMIN) {
      return "SUPER ADMIN";
    } else {
      return role;
    }
  };

  useEffect(() => {
    if (closeNavbarButton) {
      closeNavBarInstantly();
    }
  }, [closeNavbarButton]);

  const handleClick = (ev) => {
    ev.stopPropagation();
    // setHideHeaderOptions((prev) => !prev);
    setShowHeaderOptions(true);
  };

  useEffect(() => {
    setShowHeaderOptions(hideHeaderOption);
  }, [hideHeaderOption]);

  useEffect(() => {
    const scrollElement = document.querySelector(".navbar-modal-scroll");

    if (scrollElement) {
      const handleMouseEnter = () => {
        scrollElement.classList.add("scrollbar-hovered");
      };

      const handleMouseLeave = () => {
        scrollElement.classList.remove("scrollbar-hovered");
      };

      scrollElement.addEventListener("mouseenter", handleMouseEnter);
      scrollElement.addEventListener("mouseleave", handleMouseLeave);

      return () => {
        scrollElement.removeEventListener("mouseenter", handleMouseEnter);
        scrollElement.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
  }, [document.querySelector(".navbar-modal-scroll")]);

  useEffect(()=>{
    if(list != undefined && list.length > 0){
      let filterShow = listTemp.filter((ele, ind) => {
        if (ele.show == true) return ele;
      });
      let borderTop = "10px 10px 0 0";
      let borderBottom = "0 0 10px 10px";
      filterShow.map((item,id)=>{

        if(item.path == ""){
          
          if(document.getElementById(filterShow[id-1].id) !== null){
            if(roles[0] === USERTYPES.FIRMADMIN && filterShow[id-1].id == "report-templates"){
              document.getElementById(filterShow[id-1].id).style.borderRadius = "10px";
            }else{
              document.getElementById(filterShow[id-1].id).style.borderRadius = borderBottom;
            }
          }
          // if(document.getElementById(filterShow[id+1].id) !== null){
          //   document.getElementById(filterShow[id+1].id).style.borderRadius = borderTop;
          // }
          if (
            filterShow[id + 1]?.id &&
            document.getElementById(filterShow[id + 1].id)
          ) {
            document.getElementById(filterShow[id + 1].id).style.borderRadius = borderTop;
          }
          if(document.getElementById(filterShow[0].id) !== null){
            document.getElementById(filterShow[0].id).style.borderRadius = borderTop;
          }
          if(document.getElementById(filterShow[filterShow.length-1].id) !== null){
            document.getElementById(filterShow[filterShow.length-1].id).style.borderRadius = borderBottom;
          }
        }
      })
    }
  },[list])


  return (
    <>
      <div className={`h100 w100 ${!studyViewer ? "body-parent" : ""}`}>
        {!studyViewer && showPasswordExpiryMessage && (
          <div className="password-expiry-msg">
            <span
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              Your password is going to expire in {daysRemainingForExpiry} days.
              Kindly change your password.
              {!currentPath.includes("change-pwd") && (
                <button
                  className="password-expiry-reset-btn"
                  onClick={() => window.open(AuthRoutes.CHANGEPWD, "_self")}
                >
                  {t("change-password.change-password")}
                </button>
              )}
            </span>
            <div
              onClick={handleHidePasswordExpiryMessage}
              style={{
                display: "flex",
                alignItems: "center",
                color: "white",
                cursor: "pointer",
              }}
            >
              <ClearIcon />
            </div>
          </div>
        )}
        <div
          className="w100"
          style={{
            height: (!studyViewer && showPasswordExpiryMessage) ? "calc(100% - 25px)" : "100%",
            display: "flex",
            flexDirection: "row",
          }}
        >
          {!studyViewer && !isMobile && (
            <div data-tut={"tour-category"} className="navbar-container"
              style={{boxShadow: themeName === "light" ? "unset":"0px 0.6px 1.8px rgba(0, 0, 0, 0.394), 0px 3.2px 7.2px rgba(0, 0, 0, 0.468)"}}
            >
              <nav
                className="navbar-menu "
                //onMouseEnter={() => openNavBar()}
                onMouseLeave={() =>
                  !closeNavbarButton
                    ? closeNavBar()
                    : console.log("Disabling event")
                }
                style={{
                  width: windowTemp === false ? 230 : 65,
                  boxShadow: themeName === "light" ? "unset" : "1px 1px 3px rgb(0 0 0 / 8%)",
                  height: showPasswordExpiryMessage
                    ? "calc(100vh - 25px)"
                    : "100vh",
                }}
              >
                <div
                  className="navbar-left-bar-open-icon"
                  style={{
                    justifyContent:
                      windowTemp !== false ? "center" : "flex-end",
                  }}
                >
                  {windowTemp === false ? (
                    <div
                      onClick={() => setCloseNavbarButton(true)}
                      style={{
                        cursor: "pointer",
                        textAlign: "end",
                        paddingRight: "20px",
                      }}
                    >
                      <LeftArrowIcon />
                    </div>
                  ) : (
                    <div
                      onClick={() => openNavBar()}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                      }}
                    >
                      <HandBurgerIcon />
                    </div>
                  )}
                </div>
                <ul
                  className="navbar__list navbar-modal-scroll"
                  style={{
                    overflowY: "auto",
                    marginBlockEnd: "0px",
                    marginTop: "0px",
                  }}
                >
                  {list?.length > 0 &&
                    list.map(
                      (item, i) =>
                        item.show && (
                          <React.Fragment key={item.id}>
                            <CustomToolTipHost
                              content={
                                item.path != "" && windowTemp != false
                                  ? item.title
                                  : ""
                              }
                              tooltipProps={{
                                calloutProps: {
                                  styles: {
                                    beak: {
                                      background: getThemeColor("tooltip"),
                                    },
                                    beakCurtain: {
                                      background: getThemeColor("tooltip"),
                                    },
                                    calloutMain: {
                                      background: getThemeColor("tooltip"),
                                    },
                                    borderRadius: "5px",
                                    boxShadow:
                                      "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
                                  },
                                },
                              }}
                              directionalHint={DirectionalHint.rightCenter}
                              id={item.id}
                            >
                              <Callout
                                styles={{ background: "white" }}
                                // Other Callout props can be added here if needed
                              />
                              <div
                                id={item.id}
                                //onClick={(e)=> item.path==""?updateDropdown(item.id):null}
                                style={{
                                  pointerEvents: item.path == "" ? "none" : "",
                                  background: item.path != "" ? getThemeColor("navbar-item-background") : "",
                                  justifyContent:!windowTemp ? "flex-start":"center",
                                  margin: themeName !== "light" ? "10px 5px":"0px 5px"
                                }}
                                onMouseEnter={() => setHoveredItem(item.id)}
                                className={"navbar__li-box"}
                                key={i}
                              >
                                <div  
                                onClick={() => {
                                  if (!item.redirect && item.path !== "Not created yet") {
                                    window.location.href = item.path;
                                  }
                                }} 
                                className={activePath === item.path ? "navbar__li-inside-box active-nav-item"
                                    : "navbar__li-inside-box"}
                                  style={{width: !windowTemp?"100%":"unset"}}
                                    >
                                <a
                                  target={
                                    item.newTab != undefined && item.newTab
                                      ? "_blank"
                                      : ""
                                  }
                                  href={
                                    item.path == "Not created yet"
                                      ? ""
                                      : item.path
                                  }
                                  className={
                                    item.path == ""
                                      ? "link inactiveLink"
                                      : "link"
                                  }
                                >
                                  <div
                                    className={`nav-icon ${
                                      activePath === item.path
                                        ? "active-nav-icon"
                                        : ""
                                    }`}
                                    style={{
                                      // paddingLeft: windowTemp === false ? 27 : 12,
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width:
                                        item.path == ""
                                          ? "unset"
                                          : windowTemp !== false
                                          ? "100%"
                                          : "20%",
                                    }}
                                  >
                                    {item.icon}
                                  </div>
                                  <li
                                    className={`navbar__li ${
                                      item.path === activePath
                                        ? "navbar-active-item"
                                        : ""
                                    }`}
                                    style={{
                                      display:
                                        windowComplete === false
                                          ? "inline-block"
                                          : item.path == ""
                                          ? "flex"
                                          : "none",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width: "100%",
                                      marginLeft:
                                        item.path == "" &&
                                        windowComplete === false
                                          ? "10px"
                                          : "0px",
                                      fontSize:
                                        item.path == "" ? "12px" : "14px",
                                    }}
                                  >
                                    {item.title}
                                  </li>
                                </a>
                                </div>
                               
                              </div>
                            </CustomToolTipHost>
                          </React.Fragment>
                        )
                    )}
                </ul>
              </nav>
            </div>
          )}
          <div
            className={`h100`}
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: `${
                studyViewer ? "unset" : isMobile ? "unset" : "65px"
              }`,
              width: `${
                studyViewer ? "100%" : isMobile ? "100%" : "calc(100% - 65px)"
              }`,
            }}
          >
            {!studyViewer && !isMobile && (
              <div
                id="header-nav"
                className="navbar-main-style"
                style={{
                  opacity: windowTemp === false ? "50%" : "100%",
                  overflowY: "auto",
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  // marginBottom: "5px",
                }}
              >
                <div className="navbar-header-style">
                  <div
                    onClick={() => window.location.assign(AuthRoutes.STUDYLIST)}
                    style={{ display: "flex" }}
                    className="cursor-pointer"
                  >
                    {themeName !== "light" ? (
                      <RebrandingLogo fallback={<DeeptekLogo darkTheme={true} />} />
                    ) : (
                      <RebrandingLogo fallback={<Augmento />} />
                    )}
                  </div>
                  <div className="navbar-avatar-section">
                    {customerSupportNumber && !hideBranding && (
                      <>
                        <span className="navbar-customer-support">
                          Customer Support: {customerSupportNumber}
                        </span>
                        <span className="seperator"></span>
                      </> 
                    )}
                      
                      <RowBadge
                        customClassName="study-list-header-role"
                        name={getRoleName(roles[0])}
                      />

                    <span className="navbar-user-name">{name}</span>
                    <div style={{ position: "relative" }}>
                      <div
                        style={{
                          position: "relative",
                          cursor: "pointer",
                          width: "20px",
                          height: "20px",
                        }}
                        onClick={(ev) => {
                          handleClick(ev);
                        }}
                      >
                        <DownArrow
                          theme={themeName}
                          active={showHeaderOption}
                        />
                      </div>
                    </div>
                  </div>   
                </div>
              </div>
            )}
            <div
              className={`${
                studyViewer
                  ? `h100 v100 ${
                      window.location.pathname === "/" ||
                      window.location.pathname.includes("/login")
                        ? ""
                        : "main-viewer-body"
                    }`
                  : ""
              }`}
              id="main-container-div-id"
              style={{
                opacity: windowTemp === false ? "50%" : "100%",
                pointerEvents: windowTemp === false ? "none" : "unset",
                height: `${studyViewer ? "100%" : "calc(100% - 55px)"}`
              }}
            >
              {showModal.appFailer ? (
                <NotAllowed msg={showModal.description} />
              ) : (
                <RouterProvider router={RouterConfig}></RouterProvider>
              )}
            </div>
          </div>
        </div>
        {showHeaderOption && (
          <HeaderDropdown
            show={showHeaderOption}
            onClickOutside={() => {
              setShowHeaderOptions(false);
            }}
            setShowHeaderOptions={setShowHeaderOptions}
            firmName={firmName}
          />
        )}
      </div>
    </>
  );
};

export default Navbar;
